<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>
    <li class="breadcrumb-item active" aria-current="page">
      {{ "Form.Project" | translate }} / {{ currentProject.name }}
    </li>
    <div
      style="
        position: absolute;
        right: 30px;
        top: 245px;
        display: flex;
        gap: 15px;
      "
    >
      <div
        *ngIf="
          activeTabId === 'screen-tab-id' ||
          activeTabId === 'variable-tab-id' ||
          activeTabId === 'custom-tab-id'
        "
      >
        <div style="text-align: end" class="mr-2 pr-2">
          Select Version:
          <select
            (change)="
              onDropdownVersionChange(currentProject.id, $event.target.value)
            "
            class="px-3 py-2 px-2 m-1 p-1"
            style="border-radius: 5px"
          >
            <option
              style="color: #3f6ad8"
              *ngFor="let item of versions"
              [value]="item.id"
            >
              {{ item.version }} ({{ item.releaseDate | date : "dd MMM yyyy" }})
            </option>
          </select>
        </div>
      </div>
      <div
        *ngIf="
          activeTabId === 'module-tab-id' ||
          activeTabId === 'version-tab-id' ||
          activeTabId === 'variable-tab-id' ||
          activeTabId === 'custom-tab-id' ||
          activeTabId === 'screen-tab-id' ||
          activeTabId === 'role-tab-id'
        "
      >
        <div
          class="main-button mr-2 ml-2 pr-2 pl-2"
          *ngIf="
            activeTabId === 'module-tab-id' ||
            activeTabId === 'version-tab-id' ||
            activeTabId === 'variable-tab-id' ||
            activeTabId === 'custom-tab-id' ||
            activeTabId === 'screen-tab-id' ||
            activeTabId === 'role-tab-id'
          "
        >
          <button
            *ngIf="activeTabId === 'module-tab-id'"
            style="height: 30px; justify-content: center"
            placement="left"
            ngbTooltip="Add Module"
            type="button"
            class="btn-shadow d-inline-flex align-items-center btn btn-primary px-2"
            (click)="open(content); moduleId = null; onReset()"
          >
            +
          </button>
          <button
            *ngIf="activeTabId === 'version-tab-id'"
            style="height: 30px; justify-content: center"
            type="button"
            placement="left"
            ngbTooltip="{{ 'Form.AddVersion' | translate }}"
            class="btn-shadow d-inline-flex align-items-center btn btn-primary px-2"
            (click)="openPopup(); $event.stopPropagation()"
          >
            +
          </button>
          <button
            *ngIf="activeTabId === 'variable-tab-id'"
            style="height: 30px; justify-content: center"
            type="button"
            placement="left"
            ngbTooltip="{{ 'Form.AddVariable' | translate }}"
            class="btn-shadow d-inline-flex align-items-center btn btn-primary px-2"
            (click)="openVariablePopup(); $event.stopPropagation()"
          >
            +
          </button>
          <button
            *ngIf="activeTabId === 'custom-tab-id'"
            style="height: 30px; justify-content: center"
            type="button"
            placement="left"
            ngbTooltip="{{ 'Form.AddClassForUserGuide' | translate }}"
            class="btn-shadow d-inline-flex align-items-center btn btn-primary px-2"
            (click)="openUserGuideClassPopup(); $event.stopPropagation()"
          >
            +
          </button>
          <button
            *ngIf="activeTabId === 'role-tab-id'"
            style="height: 30px; justify-content: center"
            type="button"
            placement="left"
            ngbTooltip="{{ 'Form.Roles' | translate }}"
            class="btn btn-primary btn-shadow d-inline-flex align-items-center px-2"
            (click)="openRolePopup(rolepopup); $event.stopPropagation()"
          >
            +
          </button>
          <button
            *ngIf="
              activeTabId === 'screen-tab-id' &&
              totalScreens &&
              totalScreens.length
            "
            placement="right"
            ngbTooltip="Add Screen"
            type="button"
            class="btn btn-primary btn-shadow d-inline-flex align-items-center px-2"
            (click)="
              clearScreenData(); screenManagement(currentProject, 'new', '')
            "
            placement="top"
          >
            +
          </button>
        </div>
      </div>
      <div class="dropdown-container">
        <div class="main-button">
          <button
            placement="bottom"
            ngbTooltip="{{ 'Form.UserGuideDownloadPDF' | translate }}"
            type="button"
            style="width: 30px; height: 30px"
            class="btn-shadow d-inline-flex align-items-center btn btn-danger btn-lg px-2"
            (click)="exportUserGuide('pdf', selectedVersionId)"
          >
            <i
              class="fa fa-download text-white"
              style="margin: 0 !important; font-size: 14px"
            ></i>
          </button>
          <span class="dropdown-arrow" (click)="toggleDropdown()">&#9662;</span>
        </div>
        <div class="dropdown-card" id="dropdown-card" *ngIf="isDropdownVisible">
          <a
            (click)="exportUserGuide('docx', selectedVersionId)"
            style="
              cursor: pointer;
              color: #2a2d72;
              font-size: large;
              padding: 5px 0px 0px 5px;
            "
            ><i class="fa fa-file-word-o" style="font-size: larger"></i>
            {{ "Form.UserGuideDownloadDocx" | translate }}</a
          >
        </div>
      </div>
    </div>
  </ol>
</nav>

<div class="mb-3 project-hdr-box">
  <div class="row">
    <div class="col-md-12 col-lg-3">
      <ul class="list-group card list-group-flush bg-warning">
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading font-size-lg">
                    {{ "Form.SCREEN" | translate }}
                  </div>
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-white">
                    {{ totalScreens?.length }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-md-12 col-lg-3">
      <ul class="list-group card list-group-flush bg-success">
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading font-size-lg text-white">
                    {{ "Form.TOOLTIPS" | translate }}
                  </div>
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-white">
                    {{ tooltipsCount }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-md-12 col-lg-3">
      <ul class="list-group card list-group-flush bg-primary">
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading font-size-lg text-white">
                    {{ "Form.WORKFLOW" | translate }}
                  </div>
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-white">
                    {{ workflowCount }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col-md-12 col-lg-3">
      <ul class="list-group card list-group-flush bg-danger">
        <li class="bg-transparent list-group-item">
          <div class="widget-content p-0">
            <div class="widget-content-outer">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading text-white font-size-lg">
                    {{ "Form.FAQ" | translate }}
                  </div>
                </div>
                <div class="widget-content-right">
                  <div class="widget-numbers text-white">
                    {{ faqCount }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<ul
  ngbNav
  #nav="ngbNav"
  [destroyOnHide]="true"
  class="nav nav-pills"
  (navChange)="tabchange($event)"
  [(activeId)]="activeTabId"
>
  <li [ngbNavItem]="'project-tab-id'">
    <a ngbNavLink>
      <span (click)="tabchange('project-tab-id')" id="project-tab-id"
        >Project</span
      >
    </a>
    <ng-template ngbNavContent>
      <div class="row">&nbsp;</div>
      <app-project-detail></app-project-detail>
    </ng-template>
  </li>
  <li [ngbNavItem]="'screen-tab-id'">
    <a ngbNavLink>
      <span (click)="tabchange('screen-tab-id')" id="screen-tab-id"
        >Screen</span
      >
    </a>
    <ng-template ngbNavContent
      ><div *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <!-- <div class="row">&nbsp;</div> -->
      <div class="row">&nbsp;</div>
      <div class="d-flex justify-content-end">
        <!-- <div class="row"> -->

        <!-- </div> -->
      </div>
      <div class="mb-3 card" style="clear: both" *ngIf="!totalScreens?.length">
        <div class="col-sm-12">
          <div class="card no-shadow rm-border bg-transparent widget-chart">
            <div class="widget-numbers" style="font-size: 22px">
              {{ "Form.NOSCREEN" | translate }}
            </div>
          </div>
        </div>

        <div class="text-center d-block p-3">
          <button
            class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg"
            style="justify-content: center"
            (click)="clearScreenData(); screenManagement(currentProject, 'new')"
          >
            <span class="me-1">{{ "Form.ADDSCREEN" | translate }}</span>
          </button>
        </div>
      </div>

      <div class="row">&nbsp;</div>
      <div class="row" *ngIf="totalScreens && totalScreens.length">
        <div
          class="col-md-6 col-xl-4 screen-box"
          *ngFor="let sm of totalScreens"
        >
          <div
            class="card mb-3 p-0 widget-chart widget-chart2 border-0 text-left card-btm-border card-shadow-secondary border-secondary"
          >
            <div class="widget-chat-wrapper-outer">
              <div class="widget-chart-content border-bottom p-3 pb-1">
                <div class="widget-chart-flex">
                  <div
                    class="widget-numbers"
                    style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                    title="{{ sm.name }}"
                  >
                    <div class="widget-chart-flex">
                      <div
                        class="box-heading"
                        style="
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        "
                      >
                        <span>{{ sm.name }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="text-center">
                    <span
                      mat-icon-button
                      style="cursor: pointer"
                      [matMenuTriggerFor]="menu"
                      class="actions-icon-btn pt-3 pb-1 px-2"
                    >
                      <mat-icon
                        class="mat-icon notranslate material-icons text-center ps-2 pt-2 btn-icon-only bg-transparent mat-icon-no-color"
                        >more_vert</mat-icon
                      >
                    </span>

                    <mat-menu #menu="matMenu">
                      <button
                        mat-menu-item
                        (click)="screenManagement(currentProject, 'old', sm)"
                        class="text-center"
                      >
                        <span
                          class="bg-transparent"
                          matTooltip="{{ 'Form.EDIT' | translate }}"
                          matTooltipPosition="right"
                        >
                          <i
                            class="fa fa-pencil-square-o text-primary font-size-lg"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="openDeleteConfirmationDialog(sm)"
                        class="text-center"
                      >
                        <span
                          class="bg-transparent"
                          matTooltip="{{ 'Form.DELETE' | translate }}"
                          matTooltipPosition="right"
                        >
                          <i
                            class="fa fa-trash-o text-danger font-size-lg"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
                <h6
                  [title]="sm.url"
                  class="widget-subheading mt-2 mb-3 font-size-sm text-info opacity-5 text-start"
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ sm.url }}
                </h6>

                <div class="mb-3 project-box">
                  <div class="g-0 row">
                    <div class="col-md-12 col-lg-6">
                      <ul class="list-group list-group-flush">
                        <li class="bg-transparent list-group-item">
                          <div class="widget-content">
                            <div class="widget-content-outer">
                              <div class="widget-content-wrapper">
                                <div class="widget-content-left">
                                  <div class="widget-heading">
                                    <a
                                      [routerLink]="[
                                        '/page/project-detail-edit',
                                        currentProject.id,
                                        'screens',
                                        sm.id,
                                        'tooltips'
                                      ]"
                                      class="nav-link p-0"
                                      >{{ "Form.TOOLTIPS" | translate }}</a
                                    >
                                  </div>
                                </div>
                                <div class="widget-content-right">
                                  <div class="widget-numbers text-success">
                                    {{ sm.count.tooltips }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <ul class="list-group list-group-flush">
                        <li class="bg-transparent list-group-item">
                          <div class="widget-content">
                            <div class="widget-content-outer">
                              <div class="widget-content-wrapper">
                                <div class="widget-content-left">
                                  <div class="widget-heading">
                                    <a
                                      [routerLink]="[
                                        '/page/project-detail-edit',
                                        currentProject.id,
                                        'screens',
                                        sm.id,
                                        'workflows'
                                      ]"
                                      class="nav-link p-0"
                                      >{{ "Form.WORKFLOW" | translate }}</a
                                    >
                                  </div>
                                </div>
                                <div class="widget-content-right">
                                  <div class="widget-numbers text-primary">
                                    {{ sm.count.workflows }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <ul class="list-group list-group-flush">
                        <li class="bg-transparent list-group-item">
                          <div class="widget-content">
                            <div class="widget-content-outer">
                              <div class="widget-content-wrapper">
                                <div class="widget-content-left">
                                  <div class="widget-heading">
                                    <a
                                      [routerLink]="[
                                        '/page/project-detail-edit',
                                        currentProject.id,
                                        'screens',
                                        sm.id,
                                        'faqs'
                                      ]"
                                      class="nav-link"
                                      class="nav-link p-0"
                                      >{{ "Form.FAQ" | translate }}</a
                                    >
                                  </div>
                                </div>
                                <div class="widget-content-right">
                                  <div class="widget-numbers text-info">
                                    <div class="widget-numbers text-orange">
                                      {{ sm.count.faq }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <ul class="list-group list-group-flush">
                        <li class="bg-transparent list-group-item">
                          <div class="widget-content">
                            <div class="widget-content-outer">
                              <div class="widget-content-wrapper">
                                <div class="widget-content-left">
                                  <div class="widget-heading">
                                    <a
                                      [routerLink]="[
                                        '/page/project-detail-edit',
                                        currentProject.id,
                                        'screens',
                                        sm.id,
                                        'userguide'
                                      ]"
                                      class="nav-link p-0"
                                      >{{ "Form.USERGUIDE" | translate }}</a
                                    >
                                  </div>
                                </div>
                                <div class="widget-content-right">
                                  <div class="widget-numbers text-warning">
                                    {{ sm.count.userGuide }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="'module-tab-id'">
    <a ngbNavLink>
      <span (click)="tabchange('module')" id="module-tab-id">Module</span>
    </a>
    <ng-template ngbNavContent>
      <div class="row">&nbsp;</div>
      <div class="row">&nbsp;</div>
      <div class="main-card mb-3 card" *ngIf="moduleList.length">
        <div class="table-responsive">
          <table
            class="align-middle mb-0 table table-borderless table-striped table-hover"
          >
            <thead class="font-size-lg text-white">
              <tr>
                <th>
                  {{ "Form.Placeholder.ModuleNAME" | translate
                  }}<i
                    (click)="changeSort('name')"
                    style="margin-left: 10px; cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </th>
                <th>
                  {{ "Form.displayOrder" | translate
                  }}<i
                    (click)="changeSort('displayOrder')"
                    style="margin-left: 10px; cursor: pointer"
                    class="fa fa-sort"
                  ></i>
                </th>
                <th class="text-center">{{ "Form.ACTIONS" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let um of moduleList">
                <td class="text-left">{{ um.name }}</td>
                <td class="text-left">{{ um.displayOrder }}</td>
                <td class="text-center">
                  <span
                    mat-icon-button
                    style="cursor: pointer"
                    [matMenuTriggerFor]="menu"
                    class="actions-icon-btn pt-3 pb-1 px-2 bg-transparent"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </span>

                  <mat-menu #menu="matMenu" class="text-center">
                    <button
                      mat-menu-item
                      (click)="
                        open(content); toggleForm(um); currentModule = um
                      "
                    >
                      <span
                        class="bg-transparent"
                        placement="top"
                        ngbTooltip="Edit"
                      >
                        <i
                          class="fa fa-pencil-square-o text-primary font-size-lg"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="opemDeleteConfirmationDialog(um.id)"
                    >
                      <span
                        class="bg-transparent"
                        ngbTooltip="Delete"
                        placement="top"
                      >
                        <i
                          class="fa fa-trash-o text-danger font-size-lg"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </button>
                  </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mb-3 card" style="clear: both" *ngIf="!moduleList.length">
        <div class="col-sm-12">
          <div class="card no-shadow rm-border bg-transparent widget-chart">
            <div class="widget-numbers" style="font-size: 22px">
              {{ "Form.NOModule" | translate }}
            </div>
          </div>
        </div>

        <div class="text-center d-block p-3">
          <button
            class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg"
            style="justify-content: center"
            (click)="open(content); moduleId = null; onReset()"
          >
            <span class="me-1">{{ "Form.ADDModule" | translate }}</span>
          </button>
        </div>
      </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="'settings-tab-id'">
    <a ngbNavLink>
      <span (click)="tabchange('settings')" id="settings-tab-id">
        Settings
      </span>
    </a>
    <ng-template ngbNavContent>
      <div
        class="card p-4 configure-box main-card card col-md-12 col-xl-12 pt-5 mt-5 mx-auto mb-3"
      >
        <div class="card-title card-header ps-0 mb-3">
          {{ "Form.Configuration" | translate }}
        </div>
        <!-- Common Settings accordion -->
        <div
          ngbAccordion
          #accordion="ngbAccordion"
          class="col-12 px-0 mx-auto mb-3 accordion-class bg-white accordion-class"
        >
          <div ngbAccordionItem id="common-settings-panel" [collapsed]="true">
            <h2 ngbAccordionHeader class="card-header white">
              <button
                ngbAccordionButton
                ngbPanelToggle
                class="no-after-icon bg-transparent"
                style="
                  border: none !important;
                  width: 100% !important;
                  height: 100% !important;

                  cursor: pointer;
                "
              >
                <div class="d-flex align-items-center justify-content-between">
                  <button
                    class="btn btn-link p-0"
                    (click)="(globalConfigEnable == !globalConfigEnable)"
                  >
                    <h5 class="m-0 font-weight-bold card-title">
                      {{ "Form.CommonSettings" | translate }}
                    </h5>
                  </button>
                </div>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="bg-white">
                <div id="common-config-id" style="margin: 0px 10px">
                  <div class="form-validation">
                    <form [formGroup]="commonIconConfig" class="form-valide">
                      <div class="form-group">
                        <label class="mb-2 col-form-label" for="val-currency">
                          <span id="hide-on-label"
                            >Display Chat, Workflow & FAQ & User guide icons
                            (sets Element Identifier as
                            <strong>Float</strong> )</span
                          >
                        </label>

                        <!-- <div class="col-lg-12 d-flex px-0"> -->
                        <div class="custom-radio mt-2 mb-0 pb-0 custom-control">
                          <input
                            class="custom-control-input"
                            id="_tas-icon-horizontal-float"
                            name="floatValue"
                            type="radio"
                            value="hFloat"
                            checked
                            formControlName="floatValue"
                          />
                          <label
                            class="custom-control-label"
                            for="_tas-icon-horizontal-float"
                            >Horizontal Float</label
                          >
                        </div>
                        <br />
                        <div class="custom-radio custom-control">
                          <input
                            class="custom-control-input"
                            id="_tas-icon-vertical-float"
                            name="floatValue"
                            type="radio"
                            value="vFloat"
                            formControlName="floatValue"
                          />
                          <label
                            class="custom-control-label"
                            for="_tas-icon-vertical-float"
                            >Vertical Float</label
                          >
                        </div>
                        <!-- </div> -->
                      </div>
                      <div class="form-group mt-5">
                        <label class="mb-2 col-form-label" for="val-currency">
                          <span id="hide-on-label"
                            >Enable TheAppSherpa features for
                          </span>
                        </label>

                        <!-- <div class="col-lg-12 d-flex px-0"> -->
                        <div class="custom-radio mt-2 mb-0 pb-0 custom-control">
                          <input
                            class="custom-control-input"
                            id="_tas-icon-authenticated-users"
                            name="iconVisibility"
                            type="radio"
                            value="authenticated"
                            formControlName="iconVisibility"
                          />
                          <label
                            class="custom-control-label"
                            for="_tas-icon-authenticated-users"
                            >Authenticated Users Only</label
                          >
                        </div>
                        <br />
                        <div class="custom-radio custom-control">
                          <input
                            class="custom-control-input"
                            id="_tas-icon-unauthenticated-users"
                            name="iconVisibility"
                            type="radio"
                            value="unauthenticated"
                            formControlName="iconVisibility"
                          />
                          <label
                            class="custom-control-label"
                            for="_tas-icon-unauthenticated-users"
                            >Open Access (Unauthenticated Users)</label
                          >
                        </div>
                        <!-- </div> -->
                      </div>
                      <div class="form-group row">
                        <div
                          class="d-grid gap-2 d-md-flex justify-content-md-start mt-2 pt-2"
                        >
                          <button
                            id="save-tooltip-config-id"
                            type="submit"
                            (click)="onCommonIconSettingsSubmit()"
                            class="btn btn-primary"
                          >
                            {{ "Form.SAVE" | translate }}
                          </button>
                          <button
                            class="btn btn-secondary btn-lg font-size-lg text-white ms-1"
                            (click)="onCommonIconSettingsReset()"
                          >
                            {{ "Form.CANCEL" | translate }}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Language configuration -->
        <!--        <div
          ngbAccordion
          #accordion="ngbAccordion"
          class="col-12 px-0 mx-auto mb-3 accordion-class bg-white"
        >
          <div ngbAccordionItem [collapsed]="true">
            <h2 ngbAccordionHeader class="card-header bg-white">
              <button ngbAccordionButton class="no-after-icon bg-white">
                <button
                  ngbPanelToggle
                  style="
                    border: none !important;
                    width: 100% !important;
                    height: 100% !important;
                    background-color: transparent !important;
                    cursor: pointer;
                  "
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <button
                      class="btn btn-link p-0"
                      (click)="globalConfigEnable = !globalConfigEnable"
                    >
                      <h5 class="m-0 font-weight-bold card-title bg-white">
                        {{ "Form.LanguageGeneralConfiguration" | translate }}
                      </h5>
                    </button>
                  </div>
                </button>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="bg-white">
                <div id="tooltip-global-config-id" style="margin: 0px 10px">
                  <div class="form-validation">
                    <form [formGroup]="languageConfigForm" class="form-valide">
                      <div class="form-group row">
                        <label
                          class="col-lg-4 col-form-label"
                          for="val-currency"
                        >
                          <span>{{
                            "Form.EnableLanguageList" | translate
                          }}</span>
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="isLanguageList"
                          />
                        </div>
                      </div>
                      <ng-container
                        *ngIf="languageConfigForm.get('isLanguageList')?.value"
                      >
                        <div class="form-group row">
                          <label
                            class="col-lg-4 col-form-label"
                            for="val-currency"
                            >{{ "Form.ElementSelector" | translate }}</label
                          >
                          <div class="col-lg-6">
                            <input
                              formControlName="elementSelector"
                              name="elementSelector"
                              id="elementSelector"
                              type="text"
                              placeholder="{{
                                'Form.SelectPluginElement' | translate
                              }}"
                              class="form-control"
                              readonly
                            />
                          </div>
                        </div>
                         <div class="form-group row">
             <label
               class="col-lg-4 col-form-label"
               for="val-currency"
               >{{ "Form.ElementSelector" | translate }}</label
             >
             <div class="col-lg-6">
               <input
                 formControlName="elementSelector"
                 name="elementSelector"
                 id="elementSelector"
                 type="text"
                 placeholder="{{
                   'Form.SelectPluginElement' | translate
                 }}"
                 class="form-control"
                 readonly
               />
             </div>
           </div>

           <div class="form-group row">
             <label
               class="col-lg-4 col-form-label"
               for="val-currency"
               ><span>{{
                 "Form.Element" | translate
               }}</span></label
             >
             <div class="col-lg-6">
               <input
                 formControlName="triggerElement"
                 name="triggerElement"
                 id="triggerElement"
                 type="text"
                 placeholder="{{
                   'Form.SelectPluginElement' | translate
                 }}"
                 class="form-control"
                 readonly
               />
             </div>
           </div>

           <div class="form-group row">
             <label
               class="col-lg-4 col-form-label"
               for="val-currency"
             >
               <span>{{
                 "Form.LanguageListType" | translate
               }}</span>
             </label>
             <div class="col-lg-6">
               <select
                 id="languageType-element"
                 class="form-control"
                 name="languageType"
                 formControlName="languageType"
               >
                 <option value="Dropdown">
                   {{ "Form.Dropdown" | translate }}
                 </option>
                 <option value="Icon">
                   {{ "Form.Icon" | translate }}
                 </option>
                 <option value="CustomIcon">Custom Icon</option>
               </select>
             </div>
           </div>

           <div
             class="form-group row"
             *ngIf="
               languageConfigForm.get('languageType').value ==
               'Icon'
             "
           >
             <label
               class="col-lg-4 col-form-label"
               for="val-currency"
             >
               <span>{{
                 "Form.LanguageIconCSS" | translate
               }}</span>
             </label>
             <div class="col-lg-6">
               <textarea
                 id="icon-style"
                 class="form-control"
                 rows="4"
                 cols="50"
                 name="style"
                 placeholder="{{
                   'Form.LanguageIconCSS' | translate
                 }}"
                 formControlName="languageIconCss"
               >
               </textarea>
             </div>
           </div>

           <div
             class="form-group row"
             *ngIf="
               languageConfigForm.get('languageType').value ==
               'Dropdown'
             "
           >
             <label
               class="col-lg-4 col-form-label"
               for="val-currency"
             >
               <span>{{
                 "Form.LanguageListCSS" | translate
               }}</span>
             </label>
             <div class="col-lg-6">
               <textarea
                 id="icon-style"
                 class="form-control"
                 rows="4"
                 cols="50"
                 name="style"
                 placeholder="{{
                   'Form.LanguageListCSS' | translate
                 }}"
                 formControlName="languageListCss"
               >
               </textarea>
             </div>
           </div>

           <div
             class="d-grid gap-2 d-md-flex justify-content-md-start mt-2 pt-2"
           >
             <div class="col-lg-8 ml-auto">
               <button
                 id="save-tooltip-config-id"
                 type="submit"
                 (click)="
                   onLanguageGlobalSubmit(
                     languageGlobalConfig &&
                       languageGlobalConfig.id
                       ? true
                       : false
                   )
                 "
                 class="btn btn-primary"
               >
                 {{ "Form.SAVE" | translate }}
               </button>
               <button
                 class="btn reset-btn btn-lg font-size-lg text-white ml-1"
                 (click)="onLanguageGlobalConfigReset()"
               >
                 {{ "Form.CANCEL" | translate }}
               </button>
             </div>
           </div>
                      </ng-container>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- Tooltip global configuration -->
        <div
          ngbAccordion
          #accordion="ngbAccordion"
          class="col-12 px-0 mx-auto mb-3 accordion-class bg-white accordion-class"
        >
          <div ngbAccordionItem class="bg-white" [collapsed]="true">
            <h2 ngbAccordionHeader class="card-header bg-white">
              <button ngbAccordionButton class="no-after-icon">
                <button
                  ngbPanelToggle
                  style="
                    border: none !important;
                    width: 100% !important;
                    height: 100% !important;
                    background-color: transparent !important;
                    cursor: pointer;
                  "
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <button
                      class="btn btn-link p-0"
                      (click)="globalConfigEnable = !globalConfigEnable"
                    >
                      <h5 class="m-0 font-weight-bold card-title bg-white">
                        {{ "Form.TooltipGeneralConfiguration" | translate }}
                      </h5>
                    </button>
                  </div>
                </button>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="bg-white">
                <div id="tooltip-global-config-id" style="margin: 0px 10px">
                  <div class="form-validation">
                    <form
                      [formGroup]="tooltipConfigForm"
                      class="form-valide tooltip-confg"
                    >
                      <div class="row">
                        <div class="col-lg-6 px-0">
                          <div class="form-group mb-5">
                            <label
                              class="col-form-label mb-2"
                              for="val-currency"
                              ><span id="show-on-label"
                                >{{ "Form.TooltipShow" | translate }}:</span
                              ><span class="text-danger"></span>
                            </label>
                            <div class="d-flex">
                              <div class="custom-radio custom-control">
                                <input
                                  class="custom-control-input"
                                  id="click"
                                  name="showOn"
                                  type="radio"
                                  value="click"
                                  formControlName="showOn"
                                />
                                <label
                                  class="custom-control-label"
                                  for="click"
                                  >{{ "Form.OnClick" | translate }}</label
                                >
                              </div>

                              <div class="custom-radio custom-control">
                                <input
                                  class="custom-control-input"
                                  id="Hover"
                                  name="showOn"
                                  type="radio"
                                  value="hover"
                                  formControlName="showOn"
                                />
                                <label
                                  class="custom-control-label"
                                  for="Hover"
                                  >{{ "Form.OnHover" | translate }}</label
                                >
                              </div>

                              <div class="custom-radio custom-control">
                                <input
                                  class="custom-control-input"
                                  id="Focus"
                                  name="showOn"
                                  type="radio"
                                  value="focus"
                                  formControlName="showOn"
                                />
                                <label
                                  class="custom-control-label"
                                  for="Focus"
                                  >{{ "Form.OnFocus" | translate }}</label
                                >
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <label
                              class="mb-2col-form-label"
                              for="val-currency"
                            >
                              <span id="hide-on-label">{{
                                "Form.TooltipHide" | translate
                              }}</span>
                              <span class="text-danger">*</span>
                            </label>

                            <div class="col-lg-12 d-flex px-0">
                              <div class="custom-radio custom-control">
                                <input
                                  class="custom-control-input"
                                  id="hide-on-click-outside"
                                  name="hideOn"
                                  type="radio"
                                  value="clickOutSide"
                                  formControlName="hideOn"
                                />
                                <label
                                  class="custom-control-label"
                                  for="hide-on-click-outside"
                                  >{{
                                    "Form.OnClickOutside" | translate
                                  }}</label
                                >
                              </div>

                              <div class="custom-radio custom-control">
                                <input
                                  class="custom-control-input"
                                  id="Auto"
                                  name="hideOn"
                                  type="radio"
                                  value="auto"
                                  formControlName="hideOn"
                                />
                                <label
                                  class="custom-control-label"
                                  for="Auto"
                                  >{{ "Form.Auto" | translate }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-6 px-0">
                          <div class="form-group mb-5">
                            <label
                              class="mb-2col-form-label"
                              for="val-currency"
                            >
                              <span id="icon-label">{{
                                "Form.SelectIcon" | translate
                              }}</span>
                              <span
                                *ngIf="
                                  tooltipConfigForm.get('showOn').value ==
                                  'click'
                                "
                                class="text-danger"
                                >*</span
                              >
                            </label>
                            <div class="col-lg-6 px-0">
                              <select
                                id="icon-element"
                                class="form-control"
                                name="icon"
                                formControlName="icon"
                                style="border: 1px solid #032d55"
                              >
                                <option value="">Select Icon</option>
                                <option value="Info">
                                  {{ "Form.Info" | translate }}
                                </option>
                                <option value="QuestionMark">
                                  {{ "Form.QuestiionMark" | translate }}
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group">
                            <label
                              class="mb-2 col-form-label"
                              for="val-currency"
                            >
                              <span id="icon-label">{{
                                "Form.IconType" | translate
                              }}</span>
                            </label>
                            <div class="col-lg-6 px-0">
                              <select
                                id="icon-color-element"
                                class="form-control"
                                formControlName="iconColor"
                                [(ngModel)]="iconColor"
                                (change)="iconColorValue = ''"
                              >
                                <option value="CustomColor">
                                  {{ "Form.CustomColor" | translate }}
                                </option>
                                <option value="ClassName">
                                  {{ "Form.ClassName" | translate }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div
                            class="form-group"
                            *ngIf="iconColor === 'CustomColor'"
                          >
                            <label class="col-form-label" for="val-currency">
                              <span id="icon-label">{{
                                "Form.IconColorValue" | translate
                              }}</span>
                              <span class="text-danger"> *</span>
                            </label>
                            <div class="col-lg-6 px-0">
                              <input
                                id="icon-color-value-element"
                                class="form-control input-flat"
                                type="text"
                                formControlName="iconColorValue"
                                [(ngModel)]="iconColorValue"
                              />
                              <div
                                *ngIf="
                                  tooltipConfigForm.controls['iconColorValue']
                                    ?.touched &&
                                  tooltipConfigForm.controls['iconColorValue']
                                    ?.errors?.required
                                "
                                style="
                                  width: 100%;
                                  margin-top: 0.25rem;
                                  font-size: 80%;
                                  color: #e02b1d;
                                "
                              >
                                {{ "Form.Error.IconColorValue" | translate }}
                              </div>
                            </div>
                          </div>

                          <div
                            class="form-group"
                            *ngIf="iconColor === 'ClassName'"
                          >
                            <label class="col-form-label" for="val-currency">
                              <span id="icon-label">{{
                                "Form.IconClassValue" | translate
                              }}</span>
                              <span class="text-danger"> *</span>
                            </label>
                            <div class="col-lg-6 px-0">
                              <input
                                id="icon-color-value-element"
                                class="form-control input-flat"
                                type="text"
                                formControlName="iconColorValue"
                                [(ngModel)]="iconColorValue"
                              />
                              <div
                                *ngIf="
                                  tooltipConfigForm.controls['iconColorValue']
                                    ?.touched &&
                                  tooltipConfigForm.controls['iconColorValue']
                                    ?.errors?.required
                                "
                                style="
                                  width: 100%;
                                  margin-top: 0.25rem;
                                  font-size: 80%;
                                  color: #e02b1d;
                                "
                              >
                                {{ "Form.Error.IconClassValue" | translate }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="form-group d-flex gap-2 mb-0 row"> -->
                      <div
                        class="d-grid gap-2 d-md-flex justify-content-md-start mt-2 pt-2"
                      >
                        <button
                          id="save-tooltip-config-id"
                          style="margin-right: 10px"
                          type="submit"
                          (click)="onTooltipGlobalSubmit()"
                          class="btn btn-primary btn-lg font-size-lg px-5"
                        >
                          {{ "Form.SAVE" | translate }}
                        </button>
                        <button
                          class="btn btn-secondary btn-lg font-size-lg text-white"
                          (click)="onTooltipGlobalConfigReset()"
                        >
                          {{ "Form.CANCEL" | translate }}
                        </button>
                      </div>
                      <!-- </div> -->
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Workflow general configuration -->
        <div
          ngbAccordion
          #accordion="ngbAccordion"
          class="col-12 px-0 mx-auto mb-3 accordion-class bg-white accordion-class"
        >
          <div ngbAccordionItem [collapsed]="true">
            <h2 ngbAccordionHeader class="card-header">
              <button ngbAccordionButton class="no-after-icon">
                <button
                  ngbPanelToggle
                  style="
                    border: none !important;
                    width: 100% !important;
                    height: 100% !important;
                    background-color: transparent !important;
                    cursor: pointer;
                  "
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <button
                      class="btn btn-link p-0"
                      (click)="globalConfigEnable = !globalConfigEnable"
                    >
                      <h5 class="m-0 font-weight-bold card-title">
                        {{ "Form.WorkflowGeneralConfiguration" | translate }}
                      </h5>
                    </button>
                  </div>
                </button>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <div id="workflow-global-config-id" style="margin: 0px 10px">
                  <div class="form-validation">
                    <form [formGroup]="workflowConfigForm" class="form-valide">
                      <div class="form-group row">
                        <label
                          id="skip-label"
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.SkipLabel" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            id="skip-label-element"
                            class="form-control input-flat"
                            type="text"
                            formControlName="skipLabel"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                          id="done-label"
                        >
                          {{ "Form.DoneLabel" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            id="done-label-element"
                            class="form-control input-flat"
                            type="text"
                            formControlName="doneLabel"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                          id="next-label"
                        >
                          {{ "Form.NextLabel" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            id="next-label-element"
                            class="form-control input-flat"
                            type="text"
                            formControlName="nextLabel"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                          id="previous-label"
                        >
                          {{ "Form.PreviousLabel" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            id="previous-label-element"
                            class="form-control input-flat"
                            type="text"
                            formControlName="prevLabel"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                        >
                          <span>{{ "Form.NextPageUrlLabel" | translate }}</span>
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-control input-flat"
                            type="text"
                            formControlName="nextPageUrl"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                          id="timer-label"
                        >
                          {{ "Form.workflowTimer" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <div
                            style="
                              width: 85% !important;
                              float: left;
                              margin-right: 5px;
                              text-align: center;
                            "
                          >
                            <input
                              id="timer"
                              class="form-control"
                              type="number"
                              placeholder="{{
                                'Form.workflowTimer' | translate
                              }}"
                              formControlName="workflowTimer"
                            />
                          </div>
                          <div
                            style="
                              float: left;
                              line-height: 40px;
                              font-size: 17px;
                            "
                          >
                            seconds
                          </div>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.HidePreviousButton" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="hidePrev"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableFeedback" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="enableFeedback"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableRatings" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="enableRatings"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.ExitOnEsc" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="exitOnEsc"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.ExitOnOverlayClick" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="exitOnOverlayClick"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableWorkflowList" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="isWorkflowList"
                          />
                        </div>
                      </div>

                      <div
                        *ngIf="
                          workflowConfigForm.get('isWorkflowList')?.value ===
                          true
                        "
                      >
                        <div class="form-group row">
                          <label
                            class="col-lg-12 col-form-label"
                            for="val-currency"
                            >{{ "Form.ElementSelector" | translate }}
                          </label>
                          <div class="col-lg-6">
                            <input
                              formControlName="elementSelector"
                              name="elementSelector-workflow"
                              id="elementSelector-workflow"
                              type="text"
                              placeholder="{{
                                'Form.SelectPluginElement' | translate
                              }}"
                              class="form-control"
                              readonly
                            />
                          </div>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-lg-12 col-form-label"
                            for="val-currency"
                            >{{ "Form.Element" | translate }}
                          </label>
                          <div class="col-lg-6">
                            <input
                              formControlName="triggerElement"
                              name="triggerElement-workflow"
                              id="triggerElement-workflow"
                              type="text"
                              placeholder="{{
                                'Form.SelectPluginElement' | translate
                              }}"
                              class="form-control"
                              readonly
                            />
                          </div>
                        </div>

                        <div class="form-group row">
                          <label
                            class="col-lg-12 col-form-label"
                            for="val-currency"
                          >
                            {{ "Form.WorkflowListType" | translate }}
                          </label>
                          <div class="col-lg-6">
                            <select
                              id="workflowType-element"
                              class="form-control"
                              name="workflowType"
                              formControlName="workflowType"
                            >
                              <option value="Dropdown">
                                {{ "Form.Dropdown" | translate }}
                              </option>
                              <option value="Icon">
                                {{ "Form.Icon" | translate }}
                              </option>
                              <option value="CustomIcon">Custom Icon</option>
                            </select>
                          </div>
                        </div>

                        <div
                          class="form-group row"
                          *ngIf="
                            workflowConfigForm.get('workflowType').value ==
                            'Icon'
                          "
                        >
                          <label
                            class="col-lg-12 col-form-label"
                            for="val-currency"
                          >
                            {{ "Form.WorkflowIconCSS" | translate }}
                          </label>
                          <div class="col-lg-6">
                            <textarea
                              id="icon-style"
                              class="form-control"
                              rows="4"
                              cols="50"
                              name="style"
                              placeholder="{{
                                'Form.WorkflowIconCSS' | translate
                              }}"
                              formControlName="workfllowIconCss"
                            >
                            </textarea>
                          </div>
                        </div>

                        <div
                          class="form-group row"
                          *ngIf="
                            workflowConfigForm.get('workflowType').value ==
                            'Dropdown'
                          "
                        >
                          <label
                            class="col-lg-12 col-form-label"
                            for="val-currency"
                          >
                            {{ "Form.WorkflowListCSS" | translate }}
                          </label>
                          <div class="col-lg-6">
                            <textarea
                              id="icon-style"
                              class="form-control"
                              rows="4"
                              cols="50"
                              name="style"
                              placeholder="{{
                                'Form.WorkflowListCSS' | translate
                              }}"
                              formControlName="workfllowListCss"
                            >
                            </textarea>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <!-- <div class="col-lg-8 d-flex gap-2 ms-auto"> -->
                        <div
                          class="d-grid gap-2 d-md-flex justify-content-md-start mt-2 pt-2"
                        >
                          <button
                            id="save-tooltip-config-id"
                            type="submit"
                            (click)="
                              onWorkflowGlobalSubmit(
                                workflowGlobalConfig && workflowGlobalConfig.id
                                  ? true
                                  : false
                              )
                            "
                            class="btn btn-primary"
                          >
                            {{ "Form.SAVE" | translate }}
                          </button>
                          <button
                            class="btn btn-secondary btn-lg font-size-lg text-white ms-1"
                            (click)="onWorkflowGlobalConfigReset()"
                          >
                            {{ "Form.CANCEL" | translate }}
                          </button>
                        </div>
                        <!-- </div> -->
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Faq and userguide configuration -->
        <div
          ngbAccordion
          #accordion="ngbAccordion"
          class="col-12 px-0 mx-auto mb-3 accordion-class bg-white accordion-class"
        >
          <div ngbAccordionItem [collapsed]="true" class="accordion-class">
            <h2 ngbAccordionHeader class="card-header">
              <button ngbAccordionButton class="no-after-icon bg-transparent">
                <button
                  ngbPanelToggle
                  style="
                    border: none !important;
                    width: 100% !important;
                    height: 100% !important;
                    background-color: transparent !important;
                    cursor: pointer;
                  "
                >
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <button
                      class="btn btn-link p-0"
                      (click)="globalConfigEnable = !globalConfigEnable"
                    >
                      <h5 class="m-0 font-weight-bold card-title">
                        {{ "Form.FAQUserGuideConfiguration" | translate }}
                      </h5>
                    </button>
                  </div>
                </button>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <div id="workflow-config-id" style="margin: 0px 10px">
                  <div class="form-validation">
                    <form [formGroup]="globalConfigForm" class="form-valide">
                      <div class="form-group row">
                        <strong style="font-size: x-large">General:</strong>
                      </div>
                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableChatBot" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="enableChatBot"
                          />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableUserGuidance" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="isUserGuidance"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                          >{{
                            "Form.ElementSelectorforIcon" | translate
                          }}</label
                        >
                        <div class="col-lg-6">
                          <input
                            formControlName="elementSelector"
                            name="elementSelector-userguidence"
                            id="elementSelector-userguidence"
                            type="text"
                            placeholder="{{
                              'Form.SelectPluginElement' | translate
                            }}"
                            class="form-control"
                            readonly
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                          >{{ "Form.ElementforIcon" | translate }}</label
                        >
                        <div class="col-lg-6">
                          <input
                            formControlName="triggerElement"
                            name="triggerElement"
                            id="triggerElement"
                            type="text"
                            placeholder="{{
                              'Form.SelectPluginElement' | translate
                            }}"
                            class="form-control"
                            readonly
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.IconCSS" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <textarea
                            id="icon-style"
                            class="form-control"
                            rows="4"
                            cols="50"
                            name="style"
                            [value]="iconValue"
                            placeholder="{{ 'Form.IconCSS' | translate }}"
                            formControlName="IconCSS"
                          >
                          </textarea>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                          id="drawerWidth-label"
                        >
                          {{ "Form.DrawerWidth" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <div
                            style="
                              width: 90% !important;
                              float: left;
                              margin-right: 5px;
                              text-align: center;
                            "
                          >
                            <input
                              id="drawerWidth"
                              class="form-control"
                              type="number"
                              placeholder="{{ 'Form.DrawerWidth' | translate }}"
                              formControlName="drawerWidth"
                            />
                          </div>
                          <div
                            style="
                              float: left;
                              line-height: 40px;
                              font-size: 17px;
                            "
                          >
                            px
                          </div>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-4 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableCopyRight" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="enableCopyRight"
                          />
                        </div>
                      </div>

                      <div
                        class="form-group row"
                        *ngIf="globalConfigForm.get('enableCopyRight').value"
                      >
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                          >{{ "Form.TextFooter" | translate }}</label
                        >
                        <div class="col-lg-6">
                          <input
                            formControlName="footerText"
                            name="footerText"
                            id="footerText"
                            type="text"
                            placeholder="{{ 'Form.TextFooter' | translate }}"
                            class="form-control"
                          />
                          <p style="font-size: 12px">
                            {{ "Form.symbolUse" | translate }}
                          </p>
                          <p style="font-size: 12px">
                            {{ "Form.dynamicVariableUse" | translate }}
                          </p>
                        </div>
                      </div>

                      <div
                        class="form-group row"
                        *ngIf="globalConfigForm.get('enableCopyRight').value"
                      >
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.footerCSS" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <textarea
                            id="icon-style"
                            class="form-control"
                            rows="4"
                            cols="50"
                            name="style"
                            placeholder="{{ 'Form.footerCSS' | translate }}"
                            formControlName="footerCSS"
                          >
                          </textarea>
                        </div>
                      </div>
                      <div class="form-group row">
                        <strong style="font-size: x-large">FAQ:</strong>
                      </div>
                      <div class="form-group row">
                        <label
                          class="col-lg-4 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableFeedbackForFAQ" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="enableFeedbackFAQ"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-4 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableRatingsForFAQ" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="enableRatingsFAQ"
                          />
                        </div>
                      </div>

                      <div
                        class="form-group row"
                        *ngIf="globalConfigForm.get('isUserGuidance').value"
                      >
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.FAQQuestionCSS" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <textarea
                            id="icon-style"
                            class="form-control"
                            rows="4"
                            cols="50"
                            name="style"
                            [value]="faqQuestionValue"
                            placeholder="{{
                              'Form.FAQQuestionCSS' | translate
                            }}"
                            formControlName="FAQQuestionCSS"
                          >
                          </textarea>
                        </div>
                      </div>

                      <div
                        class="form-group row"
                        *ngIf="globalConfigForm.get('isUserGuidance').value"
                      >
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.FAQAnswerCSS" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <textarea
                            id="icon-style"
                            class="form-control"
                            rows="4"
                            cols="50"
                            name="style"
                            [value]="faqAnswerValue"
                            placeholder="{{ 'Form.FAQAnswerCSS' | translate }}"
                            formControlName="FAQAnswerCSS"
                          >
                          </textarea>
                        </div>
                      </div>

                      <div class="form-group row">
                        <strong style="font-size: x-large">User Guide:</strong>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableFeedbackForUG" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="enableFeedback"
                          />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label
                          class="col-lg-6 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.EnableRatingsForUG" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <input
                            class="form-check"
                            type="checkbox"
                            formControlName="enableRatings"
                          />
                        </div>
                      </div>

                      <div
                        class="form-group row"
                        *ngIf="globalConfigForm.get('isUserGuidance').value"
                      >
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.Userguideclasses" | translate }}
                        </label>
                        <div class="col-lg-6">
                          <textarea
                            id="icon-style"
                            class="form-control"
                            rows="4"
                            cols="50"
                            name="style"
                            [value]="userGuideCSSValue"
                            placeholder="{{
                              'Form.Userguideclasses' | translate
                            }}"
                            formControlName="userGuideClasses"
                          >
                          </textarea>
                        </div>
                      </div>

                      <div
                        class="form-group row"
                        *ngIf="globalConfigForm.get('isUserGuidance').value"
                      >
                        <label
                          class="col-lg-12 col-form-label"
                          for="val-currency"
                        >
                          {{ "Form.UserguideTemplate" | translate }}
                        </label>
                        <div class="col-lg-12">
                          <angular-editor
                            id="editor123"
                            formControlName="defaultTemplate"
                            [config]="edconfig"
                          ></angular-editor>
                        </div>
                      </div>

                      <!-- <div class="form-group d-flex gap-2 mb-0 row"> -->
                      <div
                        class="col-12 justify-content-center mt-3 pb-0 modal-footer border-0"
                      >
                        <button
                          id="save-tooltip-config-id"
                          style="margin-right: 10px"
                          type="submit"
                          class="btn btn-primary btn-lg font-size-lg px-5"
                          (click)="
                            onGlobalSubmit(
                              globalConfig && globalConfig.id ? true : false
                            )
                          "
                        >
                          {{ "Form.SAVE" | translate }}
                        </button>
                        <button
                          class="btn btn-secondary btn-lg font-size-lg text-white"
                          (click)="onGlobalConfigReset()"
                        >
                          {{ "Form.CANCEL" | translate }}
                        </button>
                      </div>
                      <!-- </div> -->
                      <div class="footer m-2 p-2">
                        <p class="text-muted">
                          The chat feature will be fully functional once the
                          content is published to production.
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="'version-tab-id'">
    <a ngbNavLink>
      <span (click)="tabchange('version-tab-id')" id="version-tab-id">{{
        "Form.Version" | translate
      }}</span>
    </a>
    <ng-template ngbNavContent>
      <div class="row">&nbsp;</div>

      <div class="mb-3 pb-3" style="clear: both" *ngIf="!versions.length">
        <div class="col-sm-12">
          <div class="card no-shadow rm-border bg-transparent widget-chart">
            <div class="widget-numbers" style="font-size: 22px">
              {{ "Form.NoVersion" | translate }}
            </div>
          </div>
        </div>

        <div class="text-center d-block p-3">
          <button
            style="justify-content: center"
            class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg"
            (click)="openPopup()"
          >
            <span class="me-1">{{ "Form.AddVersion" | translate }} </span>
          </button>
        </div>
      </div>
      <div class="row">&nbsp;</div>

      <div class="table-responsive" *ngIf="versions.length">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of versions; let i = index">
              <td style="width: 90%; align-items: center">
                <span>{{ item.version }}</span>
              </td>
              <td class="text-left" style="padding-left: 35px !important">
                <span (click)="deletVersion(item)" style="cursor: pointer">
                  <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="'variable-tab-id'">
    <a ngbNavLink>
      <span (click)="tabchange('variable-tab-id')" id="variable-tab-id"
        >Dynamic Variable</span
      >
    </a>
    <ng-template ngbNavContent>
      <div class="row">&nbsp;</div>
      <div class="row">&nbsp;</div>

      <div class="mb-3 pb-3" style="clear: both" *ngIf="!variables.length">
        <div class="col-sm-12">
          <div class="card no-shadow rm-border bg-transparent widget-chart">
            <div class="widget-numbers" style="font-size: 22px">
              {{ "Form.NoVariable" | translate }}
            </div>
          </div>
        </div>

        <div class="text-center d-block p-3">
          <button
            style="justify-content: center"
            class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg"
            (click)="openVariablePopup()"
          >
            <span class="me-1">{{ "Form.AddVariable" | translate }} </span>
          </button>
        </div>
      </div>

      <div class="table-responsive" *ngIf="variables.length">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
        >
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of variables; let i = index">
              <td style="align-items: center; width: 30%">
                <span>{{ item.key }}</span>
              </td>
              <td style="align-items: center; width: 60%">
                <span>{{ item.value }}</span>
              </td>
              <td class="text-left">
                <span
                  mat-icon-button
                  style="cursor: pointer"
                  [matMenuTriggerFor]="menu"
                  class="actions-icon-btn pt-3 pb-1 px-2 bg-transparent"
                >
                  <mat-icon>more_vert</mat-icon>
                </span>
                <mat-menu #menu="matMenu" class="text-center">
                  <button mat-menu-item (click)="openVariableEditPopup(item)">
                    <span
                      class="bg-transparent"
                      matTooltip="{{ 'Form.EDIT' | translate }}"
                      matTooltipPosition="right"
                    >
                      <i
                        class="fa fa-pencil-square-o text-primary font-size-lg"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="deleteVariable(item)"
                    *ngIf="
                      item.key != 'currentYear' &&
                      item.key != 'companyName' &&
                      item.key != 'projectName'
                    "
                  >
                    <span
                      class="bg-transparent"
                      ngbTooltip="Delete"
                      placement="top"
                    >
                      <i
                        class="fa fa-trash-o text-danger font-size-lg"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="'custom-tab-id'">
    <a ngbNavLink>
      <span (click)="tabchange('custom-tab-id')" id="custom-tab-id">{{
        "Form.Customization" | translate
      }}</span>
    </a>
    <ng-template ngbNavContent>
      <div class="row">&nbsp;</div>
      <div class="row">&nbsp;</div>

      <div class="row">&nbsp;</div>
      <div class="overlay-loader" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- No data message -->
      <div
        class="mb-3 pb-3"
        style="clear: both"
        *ngIf="!isLoading && !ugClass.length"
      >
        <div class="col-sm-12">
          <div class="card no-shadow rm-border bg-transparent widget-chart">
            <div class="widget-numbers" style="font-size: 22px">
              {{ "Form.NoUGClass" | translate }}
            </div>
          </div>
        </div>
        <div class="text-center d-block p-3">
          <button
            style="justify-content: center"
            class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg"
            (click)="openUserGuideClassPopup()"
          >
            <span class="me-1">{{
              "Form.AddClassForUserGuide" | translate
            }}</span>
          </button>
        </div>
      </div>

      <div class="table-responsive" *ngIf="!isLoading && ugClass.length">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of ugClass; let i = index">
              <td style="width: 90%; align-items: center">
                <span>{{ item.name }}</span>
              </td>
              <td class="text-left">
                <span
                  mat-icon-button
                  style="cursor: pointer"
                  [matMenuTriggerFor]="menu"
                  class="actions-icon-btn pt-3 pb-1 px-2 bg-transparent"
                >
                  <mat-icon>more_vert</mat-icon>
                </span>
                <mat-menu #menu="matMenu" class="text-center">
                  <button
                    mat-menu-item
                    (click)="openUserGuideEditClassPopup(item)"
                  >
                    <span
                      class="bg-transparent"
                      matTooltipPosition="right"
                      matTooltip="{{ 'Form.EDIT' | translate }}"
                    >
                      <i
                        class="fa fa-pencil-square-o text-primary font-size-lg"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                  <button mat-menu-item (click)="deleteClass(item)">
                    <span
                      class="bg-transparent"
                      ngbTooltip="Delete"
                      placement="top"
                    >
                      <i
                        class="fa fa-trash-o text-danger font-size-lg"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="'role-tab-id'">
    <a ngbNavLink>
      <span (click)="tabchange('role-tab-id')" id="role-tab-id">Role</span>
    </a>
    <ng-template ngbNavContent>
      <div class="row">&nbsp;</div>

      <div class="mb-3 pb-3" style="clear: both" *ngIf="!appRolesdetail.length">
        <div class="col-sm-12">
          <div class="card no-shadow rm-border bg-transparent widget-chart">
            <div class="widget-numbers" style="font-size: 22px">
              {{ "Form.NoUGClass" | translate }}
            </div>
          </div>
        </div>

        <div class="text-center d-block p-3">
          <button
            style="justify-content: center"
            class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg"
            (click)="openRolePopup(rolepopup)"
          >
            <span class="me-1">{{ "Form.Roles" | translate }} </span>
          </button>
        </div>
      </div>
      <div class="row">&nbsp;</div>
      <div class="table-responsive" *ngIf="appRolesdetail.length">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Display Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of appRolesdetail; let i = index">
              <td style="width: 50%; align-items: center">
                <span>{{ item.name }}</span>
              </td>
              <td style="width: 50%; align-items: center">
                <span>{{ item.displayname }}</span>
              </td>
              <td class="text-left">
                <span
                  mat-icon-button
                  style="cursor: pointer"
                  [matMenuTriggerFor]="menu"
                  class="actions-icon-btn pt-3 pb-1 px-2 bg-transparent"
                >
                  <mat-icon>more_vert</mat-icon>
                </span>
                <mat-menu #menu="matMenu" class="text-center">
                  <button
                    mat-menu-item
                    (click)="openEditRolePopup(rolepopup, item)"
                  >
                    <span
                      class="bg-transparent"
                      matTooltipPosition="right"
                      matTooltip="{{ 'Form.EDIT' | translate }}"
                    >
                      <i
                        class="fa fa-pencil-square-o text-primary font-size-lg"
                      ></i>
                    </span>
                  </button>

                  <button mat-menu-item (click)="deleteRole(item)">
                    <span
                      class="bg-transparent"
                      matTooltip="{{ 'Form.DELETE' | translate }}"
                      matTooltipPosition="right"
                    >
                      <i class="fa fa-trash-o text-danger font-size-lg"></i>
                    </span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav"></div>

<ng-template
  #content
  let-modal
  class="main-card mb-3 col-md-6 col-xl-4 mx-auto card add-edit-user"
>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" *ngIf="moduleId">
      {{ "Form.UpdateModule" | translate }}
    </h4>
    <h4 class="modal-title" id="modal-basic-title" *ngIf="!moduleId">
      {{ "Form.ADDModule" | translate }}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="close"
      (click)="modal.dismiss('Cross click'); moduleId = null; onReset()"
      style="border: none !important"
    >
      &times;
    </button>
  </div>
  <div class="modal-body">
    <div class="">
      <div class="card-body pt-0 ps-1">
        <form [formGroup]="form" class="needs-validation">
          <div class="position-relative row form-group mb-2">
            <label for="name_Id" class="col-sm-12 col-form-label"
              >{{ "Form.Placeholder.ModuleNAME" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="name"
                name="name"
                id="name_Id"
                maxlength="50"
                placeholder="{{ 'Form.Placeholder.ModuleNAME' | translate }}"
                type="text"
                class="form-control"
                required
              />
              <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                <div *ngIf="f.name.errors.required">
                  {{ "Form.Error.NAME" | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="position-relative row form-group mb-2">
            <label for="email_id" class="col-sm-12 col-form-label"
              >{{ "Form.displayOrder" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="col-sm-12">
              <input
                formControlName="displayOrder"
                name="displayOrder"
                id="displayOrder_id"
                placeholder="{{ 'Form.displayOrder' | translate }}"
                type="number"
                min="1"
                pattern="^[1-9]\d*$"
                class="form-control"
                required
              />
              <div
                *ngIf="submitted && f.displayOrder.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.displayOrder.errors.required">
                  {{ "Form.Error.displayOrder" | translate }}
                </div>
              </div>
              <div
                *ngIf="submitted && f.quantity.errors?.pattern"
                class="invalid-feedback"
              >
                Please enter a positive number.
              </div>
            </div>
          </div>

          <div
            class="position-relative row form-check modal-footer text-center justify-content-center"
          >
            <div class="col-sm-10 d-flex gap-2 offset-sm-2">
              <div
                class="col-12 justify-content-center mt-3 modal-footer border-0"
              >
                <button
                  class="btn btn-primary btn-lg px-5 font-size-lg"
                  style="margin-right: 10px"
                  type="submit"
                  (click)="onSubmit()"
                >
                  {{ "Form.SAVE" | translate }}
                </button>
                <button
                  class="btn btn-secondary btn-lg text-white font-size-lg"
                  (click)="onReset(); modal.dismiss('Cross click')"
                >
                  {{ "Form.CANCEL" | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>

        <!--  <div class="relevent-info mt-5 pe-3">
          <div class="">
            <h3 class="mb-4">{{ "Form.ADDITIONALINFO" | translate }}</h3>
            <p>{{ "Form.ADDITIONALINFOModuleManagement" | translate }}</p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</ng-template>

<ng-template #rolepopup let-modal>
  <div class="modal-header">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="modal-title ms-2 mb-0">{{ "Form.Add/EditRT" | translate }}</h4>
      <button
        type="button"
        class="close mt-2"
        aria-label="Close"
        (click)="d('Cross click')"
        style="border: none !important"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="card-body pt-0 ps-1">
      <form [formGroup]="roleForm">
        <div class="position-relative row form-group mb-2">
          <label for="name_Id" class="col-sm-12 col-form-label"
            >{{ "Form.DisplayName" | translate
            }}<span class="text-danger">*</span></label
          >
          <div class="col-sm-12">
            <input
              formControlName="displayname"
              name="displayname"
              id="display_name_Id"
              maxlength="50"
              placeholder="Display Name"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="position-relative row form-group mb-2">
          <label for="name_Id" class="col-sm-12 col-form-label"
            >{{ "Form.Placeholder.NAME" | translate }}
            <span class="text-danger">*</span></label
          >
          <div class="col-sm-12">
            <input
              formControlName="name"
              name="name"
              id="name_Id"
              maxlength="50"
              placeholder="Name"
              type="text"
              class="form-control"
              required
            />
            <div
              *ngIf="
                roleForm.controls['name'].hasError('noSpacesOrSpecialChars') &&
                roleForm.controls['name'].touched
              "
            >
              <small class="text-danger">{{
                "Form.Error.NoOnlySpChar" | translate
              }}</small>
            </div>
          </div>
        </div>
        <div class="row mt-2 pt-2 mb-2 pb-2">
          <div class="col-sm-10">
            <button
              class="btn btn-primary font-size-lg"
              style="margin-right: 10px; padding: 2px 6px"
              type="submit"
              [disabled]="roleForm.invalid"
              (click)="onRoleSubmit()"
            >
              {{ "Form.SAVE" | translate }}
            </button>

            <button
              type="button"
              class="btn btn-secondary font-size-lg custom-cancel-btn"
            >
              {{ "Form.CANCEL" | translate }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 text-muted">
            {{ "Form.RoleNote" | translate }}
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
